module.exports = __webpack_public_path__ + "media/images/corporate-sales/icons/inventory-fdd2f9f2d57920932a98069f0e1f1d82.svg";